import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

const ReportFilterSummaryComponent = ({ reportFilter }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        {t('Reports.ReportFilters.OrderNo')} : <span> {reportFilter.orderNo} </span>
      </Grid>
      <Grid item xs={12} sm={4}>
        {t('Reports.ReportFilters.FilterCode')} : <span> {reportFilter.filterCode} </span>
      </Grid>
      <Grid item xs={12} sm={4}>
        {t('Reports.ReportFilters.Caption')} : <span> {reportFilter.filterCaption} </span>
      </Grid>
    </Grid>
  );
};

ReportFilterSummaryComponent.propTypes = {
  reportFilter: PropTypes.object.isRequired
};

export default ReportFilterSummaryComponent;
